import React, { FunctionComponent } from 'react';
import styles from './Company.module.scss';
import { Block, ResponsiveImage, BlockContent, Typography } from 'components/elements';
import { WPAcfCompany } from 'types/acf/company';
import messages from 'messages/base-pl';
import { useIntl } from 'react-intl';
import { Fragment } from 'react';
import Description from '../Description/Description';

interface OwnProps {
  data: WPAcfCompany | null;
}

type CompanyProps = JSX.IntrinsicElements['div'] & OwnProps;

const Company: FunctionComponent<CompanyProps> = props => {
  const { formatMessage } = useIntl();
  const { data } = props;

  if (!data || (!data.header && !data.logo)) {
    return null;
  }

  const { logo, description, header } = data;

  return (
    <Fragment>
      <Block id="company" theme="light" data-module="company">
        <BlockContent direction="row">
          <ResponsiveImage className={styles.image} desktopImage={{ config: logo }} mobileImage={{ config: logo }} />
          <div className={styles.content}>
            <Typography mobile="new_neue_20_h2" tablet="new_neue_20_h2" desktop="new_neue_20_h2" className={styles.subheader}>
              {formatMessage(messages.case_study)}
            </Typography>
            <Typography mobile="new_neue_semibold_26" tablet="new_neue_semibold_26" desktop="new_neue_32_h1" as="h2" className={styles.header}>
              {header}
            </Typography>
          </div>
        </BlockContent>
      </Block>
      {description && (
        <Description
          styled={true}
          align="left"
          data={{
            description,
          }}
        />
      )}
    </Fragment>
  );
};

export default Company;
